<div class="panel-container" [ngClass]="{'toggle-panel-backdrop': enableBackdrop}">
  <div id="{{aid}}" class="panel-header" [ngClass]="{'expanded': expanded}">
    @if (showCustomHeader) {
      <div (click)="toggle()" class="d-flex p-2">
        <div>
          @if (!disabled) {
            <i class="caret far fa-chevron-down" [ngClass]="{'open': expanded}"></i>
          }
        </div>
        <ng-content select="[customHeader]"></ng-content>
        <span class="validationIcon">
          @if (validationIcon) {
            <i class="fal {{validationIcon}}"></i>
          }
        </span>
      </div>
    } @else {
      <rask-header [attr.size]="size">
        <div (click)="toggle()">
          <span>
            @if (!disabled) {
              <i class="caret far fa-chevron-down" [ngClass]="{'open': expanded}"></i>
            }
            <span class="toggel-panel-label">{{label}}</span>
            @if (helpUrl) {
              <rask-helpicon class="help-icon" [helpUrl]="helpUrl"></rask-helpicon>
            }
            <span class="badge badge-pill">{{badge}}</span>
            <span class="validationIcon">
              @if (validationIcon) {
                <i class="fal {{validationIcon}}"></i>
              }
            </span>
            <span class="icon float-end">@if (icon) {
              <i class="fal {{icon}}"></i>
            }</span>
            @if (showLoader) {
              <rask-busy-spinner class="float-end loader" size="1"></rask-busy-spinner>
            }
          </span>
        </div>
        <div class="content">
          @if (showHeader()) {
             <ng-container *ngTemplateOutlet="header()"></ng-container >
            <ng-content select="[header]"></ng-content>
          }
        </div>
      </rask-header>
    }

  </div>
  @if (expanded) {
    <div [ngClass]="getPanelBodyClass()">
      <ng-content></ng-content>
    </div>
  }
</div>